<template>
    <div v-if="!loading" class="shelf-title">
        {{ displayText }}
        <div class="shelf-title__count" >{{ displayCount }}</div>
    </div>
    <div v-else class="spinner" >
        <v-progress-circular indeterminate color="primary"/>
    </div>
</template>

<script>
export default {
    props: {
        locator: {
            type: Object,
            required: false,
            default: () => {},
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        text() {
            return this.locator?.name || this.locator?.description || this.locator?.type || '';
        },
        displayText() {
            if ( !this.text ) {
                return 'Pending Destination';
            }
            return `Destination: ${ this.text }`;
        },
        count() {
            if ( typeof this.locator?.mailItemCount === 'number' ) {
                return this.locator.mailItemCount;
            }
            if ( typeof this.locator?.onShelfCount === 'number' ) {
                return this.locator.onShelfCount;
            }
            return null;
        },
        displayCount() {
            return typeof this.count === 'number' ? `${ this.count } total items` : '';
        },
    },
};
</script>

<style lang="scss" scoped>
    .shelf-title {
        text-align: start;
        font-size: 1.5rem;
        color: $colors-grey-darken-3;
        &__count {
            font-size: 1rem;
        }
        @include mixins-above(tablet) {
            text-align: end;
        }
    }
    .spinner {
        display: flex;
        justify-content: flex-end;
    }
</style>
